module.exports = __webpack_public_path__ + "img/katze.475c1445.png";